<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="queryHandle()" size="small">
            <el-form-item label="订单编码:">
                <el-input size="small" v-model="dataForm.orderCode" placeholder="订单编码" clearable @blur="queryHandle"></el-input>
            </el-form-item>
            <el-form-item label="订单状态:">
                <el-select size="small" v-model="dataForm.orderStatus" placeholder="请选择状态" clearable @change="queryHandle">
                    <el-option v-for="item in PRODUCTION_ORDER_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单类型:">
                <el-select size="small" v-model="dataForm.orderType" placeholder="请选择类型" clearable @change="queryHandle">
                    <el-option v-for="item in SOP_ORDER_TYPE" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="物料号:">
                <el-input size="small" v-model="dataForm.partCode" placeholder="物料号" clearable @blur="queryHandle"></el-input>
            </el-form-item>
            <el-form-item label="采购组:">
                <el-select size="small" v-model="dataForm.ekgrp" placeholder="请选择采购组" filterable clearable @change="queryHandle">
                    <el-option v-for="item in GOURP_LIST" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="queryHandle()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" type="primary" @click="exportData()">
                    导出订单信息
                </el-button>
                <el-button v-if="isAuth('sourcing:sgwl:button')" size="small" plain type="primary" @click="publishOrderHandle()" icon="el-icon-plus">
                    补发邮件
                </el-button>
                <!-- <el-button v-if="isAuth('sourcing:supplier:button')" type="warning" icon="el-icon-plus">
                    同步订单
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" border style="width: 100%" @selection-change="selectionChangeHandle" :default-expand-all="false" :height="tableHeight" :header-cell-style="{ background: '#f5f5f5' }">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="orderStatus" header-align="center" align="center" label="订单状态" width="100">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.orderStatus)">
                            {{ getProductionOrderStatusByValue(scope.row.orderStatus) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderCode" header-align="center" align="left" label="订单编码" width="100">
                </el-table-column>
                <el-table-column prop="orderType" header-align="center" align="center" label="订单类型" width="150">
                    <template slot-scope="scope">
                        <span>{{ getPurchaseTypeShortName(scope.row.orderType) }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="bukrs" header-align="center" align="center" label="公司代码">
                </el-table-column>
                <el-table-column prop="butxt" header-align="center" align="left" label="公司名称">
                </el-table-column> -->
                <el-table-column prop="supplierCode" header-align="center" align="center" label="供应商编码" width="100">
                </el-table-column>
                <el-table-column prop="supplierName" header-align="center" align="left" label="供应商名称">
                </el-table-column>
                <!--
                <el-table-column prop="ekorg" header-align="center" align="left" label="采购组织">
                </el-table-column>
                <el-table-column prop="ekotx" header-align="center" align="left" label="采购组织名称" width="100">
                </el-table-column>-->
                <el-table-column prop="bedat" header-align="center" align="center" width="150" label="采购日期">
                </el-table-column>
                <el-table-column prop="ekgrp" header-align="center" align="left" label="采购组">
                </el-table-column>
                <el-table-column prop="eknam" header-align="center" align="left" label="采购组的描述" width="100">
                </el-table-column>
                <!-- <el-table-column prop="supplierCode" header-align="center" align="center" label="付款条件" width="100">
                </el-table-column> -->
                <el-table-column prop="txz02" header-align="center" align="left" label="文本描述">
                </el-table-column>

                <el-table-column header-align="center" align="center" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    getProductionOrderStatusByValue,
    PRODUCTION_ORDER_STATUS,
} from "@/utils/const";
import { getAllPurchaseTypes, formatForSelect, getPurchaseTypeShortName } from '@/utils/purchaseTypeCache'
import {
    fetchOrderOtsListBySupplier,
    publishOrder,
    getGroupOtsList,
    exportOrderOtsDataList
} from "@/controller/order";
import AddOrUpdate from "./order-add-or-update";
// require('@/mock/mockOrder');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            dataForm: {
                id: '',
                orderCode: '',
                supportingPartner: '',
                supplierName: '',
                orderStatus: '0',
                orderType: '',
                partCode: '',
                ekgrp: ''
            },
            PRODUCTION_ORDER_STATUS: PRODUCTION_ORDER_STATUS,
            getProductionOrderStatusByValue: getProductionOrderStatusByValue,
            SOP_ORDER_TYPE: [],
            getPurchaseTypeShortName: getPurchaseTypeShortName,
            GOURP_LIST: [],
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 20,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
        };
    },
    components: {
        AddOrUpdate,
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 260;
            },
        },
    },
    created() {
        getAllPurchaseTypes().then(list => {
            this.SOP_ORDER_TYPE = formatForSelect(list)
        })
    },
    activated() {
        this.getGroupOtsList();
        this.getDataList();
    },
    methods: {
        // 订单状态
        orderStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getProductionOrderStatusByValue(PRODUCTION_ORDER_STATUS, value);
        },
        // 订单类型
        // orderTypeFormat: function (value) {
        //     if (!value) {
        //         return "";
        //     }
        //     return getSopOrderTypeByValue(SOP_ORDER_TYPE, value);
        // },
        // 查询按钮
        queryHandle() {
            this.pageIndex = 1;
            this.getDataList();
        },
        // 获取采购组列表
        getGroupOtsList() {
            this.GOURP_LIST = [];
            getGroupOtsList({}).then((data) => {
                if(data.body && data.body.length != 0) {
                    data.body.forEach((info) => {
                        const group = {
                            key: info.value,
                            value: info.value,
                            label: info.label
                        }
                        this.GOURP_LIST.push(group)
                    })
                }
            })
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            fetchOrderOtsListBySupplier({
                    pageNo: this.pageIndex,
                    pageSize: this.pageSize,
                    orderCode: this.dataForm.orderCode,
                    partCode: this.dataForm.partCode,
                    supportingPartner: this.dataForm.supportingPartner,
                    supplierName: this.dataForm.supplierName,
                    orderStatus: this.dataForm.orderStatus,
                    orderType: this.dataForm.orderType,
                    ekgrp: this.dataForm.ekgrp,
                    source: 'SAP'
                })
                .then((data) => {
                    if (data && data.code === "00") {
                        this.dataList = data.body.records;
                        this.totalPage = data.body.total;
                    } else {
                        this.dataList = [];
                        this.totalPage = 0;
                    }
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.dataListLoading = false;
                });
        },
        // 发布
        publishOrderHandle() {
            if (this.dataListSelections.length === 0) {
                this.$message.warning("请选择订单")
                return
            }
            this.$confirm(`确定进行发布操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let ids = this.dataListSelections.map(item => {
                    return item.id
                })
                publishOrder(ids).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '发布成功',
                            type: 'success',
                            duration: 300,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '0':
                    className = "text-primary"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        },
        exportData() {
            const params = {
                ids : [],
                'orderCode': this.dataForm.orderCode,
                'supportingPartner': this.dataForm.supportingPartner,
                'supplierName': this.dataForm.supplierName,
                'orderStatus': this.dataForm.orderStatus,
                partCode: this.dataForm.partCode,
                // 'orderType': this.dataForm.orderType,
                'orderType': 'NB', // 标准采购订单-量产
            }
            if(this.dataListSelections && this.dataListSelections.length != 0) {
                this.dataListSelections.forEach(dataList => {
                    params.ids.push(dataList.id)
                })
            }

            exportOrderOtsDataList(params).then(data => {
                this.readAsBinaryString(data.body)
            })

        },
        readAsBinaryString(data) {
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
        },
        str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.button-danger {
    color: #f56c6c;
}

.text-danger {
    color: #f56c6c;
}

.text-success {
    color: #67c23a;
}

.text-waming {
    color: #e6a23c;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
